import { Component, computed, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent, InputComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import type { CouponFieldStatus } from '../../../../core/api/coupon/models/coupon.model';
import { TranslatePipe } from '../../../../core/i18n';

/**
 * Coupon code field and Apply button for triggering Review & Pay re-estimation.
 */
@Component({
  selector: 'app-review-coupon-code',
  imports: [
    ButtonComponent,
    InputComponent,
    ReactiveFormsModule,
    TranslatePipe,
    TypographyComponent,
  ],
  templateUrl: './review-coupon-code.html',
  styleUrl: './review-coupon-code.scss',
})
export class ReviewCouponCode {
  readonly couponControl = input.required<FormControl<string>>();
  readonly status = input<CouponFieldStatus>('idle');
  readonly applied = output<string>();

  protected readonly isInvalid = computed(() => this.status() === 'invalid');
  protected readonly isSuccess = computed(() => this.status() === 'success');
  protected readonly isBusy = computed(() => this.status() === 'loading');

  /**
   * Emits the trimmed coupon value so the page can re-estimate through the estimate API.
   */
  protected onApply(): void {
    if (this.isBusy()) {
      return;
    }
    this.applied.emit(this.couponControl().value.trim());
  }
}
